import { render, staticRenderFns } from "./BasicFertilization.vue?vue&type=template&id=e1a5083c&scoped=true&"
import script from "./BasicFertilization.vue?vue&type=script&lang=js&"
export * from "./BasicFertilization.vue?vue&type=script&lang=js&"
import style0 from "./BasicFertilization.vue?vue&type=style&index=0&id=e1a5083c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a5083c",
  null
  
)

export default component.exports